import React, { useMemo } from 'react';
import { Button, Col, DatePicker, Input, Radio, Select, Tooltip } from 'antd';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';
import { isEmpty } from 'lodash';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/RegisterTaxiDriverOverview.linkstate';
import { allAccountStatusTypes, allRegisterStatusTypes } from '../../../shared/types';

export const RegisterTaxiDriverFilter = () => {
    const isNotEmpty = (s: string) => s && !isEmpty(s);

    const [{ search, selectedRegisterStatus, selectedAccountStatus, selectedDateRange }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();

    const rangePickerValue = useMemo(() => {
        return isNotEmpty(selectedDateRange?.fromDate) && isNotEmpty(selectedDateRange?.toDate)
            ? [moment(selectedDateRange?.fromDate), moment(selectedDateRange?.toDate)]
            : [null, null];
    }, [selectedDateRange]);

    const handleRangePickerChanged = (dates: [any, any]) => {
        patchState({
            selectedDateRange:
                dates && dates[0] && dates[1]
                    ? {
                          fromDate: dates[0].format('YYYY-MM-DD'),
                          toDate: dates[1].format('YYYY-MM-DD'),
                      }
                    : undefined,
        });
    };

    const handleReload = () => {
        patchState({
            timestamp: new Date().toString(),
        });
    };

    return (
        <>
            <Col style={{ width: 350 }}>
                <Input
                    value={search}
                    placeholder={'Search by email, fullName, phone..'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
            <Col style={{ width: 200 }}>
                <Tooltip
                    title={`Filter by register type: ${(selectedRegisterStatus ?? []).map((type) => `#${type}`).join(' ')}`}
                >
                    <Select
                        placeholder="Type of register status"
                        mode="multiple"
                        value={selectedRegisterStatus ?? []}
                        style={{ width: '100%', height: 32 }}
                        maxTagCount={1}
                        maxTagTextLength={10}
                        onChange={(e) => patchState({ selectedRegisterStatus: e })}
                    >
                        {(allRegisterStatusTypes ?? []).map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Tooltip>
            </Col>
            <Col style={{ width: 200 }}>
                <Tooltip
                    title={`Filter by account status: ${(selectedAccountStatus ?? []).map((type) => `#${type}`).join(' ')}`}
                >
                    <Select
                        placeholder="Type of account status"
                        mode="multiple"
                        value={selectedAccountStatus ?? []}
                        style={{ width: '100%', height: 32 }}
                        maxTagCount={1}
                        maxTagTextLength={10}
                        onChange={(e) => patchState({ selectedAccountStatus: e })}
                    >
                        {(allAccountStatusTypes ?? []).map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Tooltip>
            </Col>
            <Col>
                <Tooltip title={`Filter by register date`}>
                    <DatePicker.RangePicker value={rangePickerValue as any} onChange={handleRangePickerChanged} />
                </Tooltip>
            </Col>
            <Col>
                <Button type="primary" icon={<ReloadOutlined />} onClick={handleReload}>
                    Reload
                </Button>
            </Col>
        </>
    );
};
